import { isEqual, isValid } from 'date-fns';
export const isPropertyIdentical = (sentValue, receivedValue) => {
    if (Array.isArray(sentValue) && Array.isArray(receivedValue)) {
        return sentValue.join('') === receivedValue.join('');
    }
    if (typeof sentValue === 'string' && typeof receivedValue === 'string') {
        const validDates = isValid(new Date(sentValue)) && isValid(new Date(receivedValue));
        if (validDates) {
            return isEqual(new Date(sentValue), new Date(receivedValue));
        }
        return sentValue === receivedValue;
    }
    return sentValue === receivedValue;
};
